import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { backToResendEmail, backToEmailForm } from "../../actions/EmailAuthenticationActions";
import { loginSteps } from "../../utilities/Constants";
import SoleSourceTitle from "newApp/controls/SoleSourceTitle";

export class VerifyEmailInfo extends Component {
    constructor (props) {
        super(props);

        this.state = {
            validationError: undefined,
        };
    }

    render () {
        if (this.props.step !== loginSteps.verifyEmailInfo)
            return null;

        const emailFrom = window.EmailFrom;

        return (
            <div className="">
                <div>
                    <SoleSourceTitle />
                    <div id="setEmailInfo" className="loginEmail-popup">
                        <div className="form-title"><span className="label-blue-mail-icon"/>Verification email
                            sent
                        </div>

                        <div className="linked-email">{this.props.email}</div>

                        <div className="form-subtitle">We have sent a verification email to your address. To
                            complete
                            the
                            sign-up process, please follow the instructions in the verification email.
                        </div>

                        <div className="form-subtitle">If you did not receive the verification email:
                            <br/>
                            <ul>
                                <li>check your spam folder</li>
                                <li>add {emailFrom} to your safe sender list</li>
                                <li>resend the verification email</li>
                            </ul>
                        </div>

                        <div className="row-link">
                            <a className="link" name="resendEmail" onClick={this.props.backToResendEmail}>Resend
                                Email</a>
                        </div>
                        <div className="row-link last-row">
                            <a className="link" name="backToLoginPage"
                                onClick={this.props.backToEmailLoginPage}>Back To
                                Login Page</a>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

VerifyEmailInfo.defaultProps = {
    email: ""
};

VerifyEmailInfo.propTypes = {
    email: PropTypes.string,
    backToResendEmail: PropTypes.func,
    backToEmailLoginPage: PropTypes.func,
    step: PropTypes.string
};

const mapStateToProps = state => ({
    email: state.loginState.email,
    step: state.loginState.loginStep
});

const mapDispatchToProps = (dispatch) => {
    return ({
        backToEmailLoginPage: () => dispatch(backToEmailForm()),
        backToResendEmail: () => dispatch(backToResendEmail())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmailInfo);
